module.exports = __webpack_public_path__ + "img/对健康有危害.25d8a9f9.jpg";